import {
  addCompanyExternalLinkAPI,
  type AddCompanyExternalLinkPayload,
} from '@/api/v4/organization-external-links.api';
import { QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { captureExceptionSafely } from '@/helpers/capture-exception-safely';
import { useCompanyFetchMode } from '../company-fetch-context';
import { useTranslation } from 'react-i18next';

export const useAddCompanyExternalLink = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();
  const fetchMode = useCompanyFetchMode();

  return useMutation({
    mutationFn: async ({ companyId, data }: AddCompanyExternalLinkPayload) => {
      return addCompanyExternalLinkAPI({ companyId, data });
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          QueryKey.CompanyExternalLinks,
          fetchMode,
          variables.companyId,
        ],
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      captureExceptionSafely(error);
    },
  });
};
